import React, {useEffect, useState} from "react";
import {Dialog} from "@mui/material";
import Pagination from "../utils/Paginations";
import './PatientsListModal.css';

function PatientListModal({open, onClose, patientList}) {
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const totalUsers = patientList.length;

    const updateTablePage = (newPage) => {
        setCurrentPage(newPage);
    };

    const paginatedPatients = patientList.slice(
        currentPage * pageSize,
        (currentPage + 1) * pageSize
    );

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 600) {
                setPageSize(5);
            } else {
                setPageSize(10);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (open) {
            setCurrentPage(0);
        }
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    width: '600px',
                    maxWidth: '90%',
                    padding: '20px',
                    overflow: 'hidden'
                }
            }}
        >
            <div className="modal-container">
                <div className="modal-header">
                    <h2>Pacientes</h2>
                    <button className="close-button" onClick={onClose} style={{fontSize: '2.5rem'}}>×</button>
                </div>
                <p className="modal-subtitle">Dados extraídos do PEP.</p>

                {patientList.length === 0 ? (
                    <p>Nenhum paciente encontrado.</p>
                ) : (
                    <table className="patient-table">
                        <thead>
                        <tr>
                            <th className="col-pep">PEP</th>
                            <th className="col-name">Nome</th>
                        </tr>
                        </thead>
                        <tbody>
                        {paginatedPatients.map((p, idx) => (
                            <tr
                                key={idx}
                                onClick={() => {
                                    window.location.href = `/chat/new?context=resumo_paciente&id=${p.id}`;
                                }}
                            >
                                <td>{p.id}</td>
                                <td>{p.name?.trim() ? p.name : '-'}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}

                <Pagination
                    cPage={currentPage}
                    pageSize={pageSize}
                    countOrders={totalUsers}
                    updateTablePage={updateTablePage}
                />
            </div>
        </Dialog>
    );
}

export default PatientListModal;
